const linkLandingPagesNL = {
    "view": {
        "table": {
            "title": "Uw linklandingspagina's",
            "column": {
                "title": "Titel",
                "description": "Beschrijving",
                "backUrl": "Terug Url",
                "created": "Gemaakt",
                "landingPage": "Landingspagina",
                "action": "Actie"
            },
            "label": {
                "landingPage": "Landingspagina"
            },
            "button": {
                "view": "Bekijken",
                "export_csv": "Exporteer CSV"
            },
            "placeholder": {
                "search": "Zoeken..."
            },
            "message": {
                "linkCopied": "Link gekopieerd naar klembord!"
            }
        },
        "modal": {
            "edit": {
                "header": "Bewerk {{linkLandingPageName}}?",
                "body": "Weet u zeker dat u deze linklandingspagina wilt bewerken?"
            },
            "delete": {
                "header": "Verwijder {{linkLandingPageName}}?",
                "body": "Weet u zeker dat u deze linklandingspagina wilt verwijderen?"
            }
        },
        "message": {
            "success": "Linklandingspagina is verwijderd!",
            "error": "Er is iets misgegaan! Vernieuw de pagina en probeer het opnieuw!",
            "llpAllowanceSpent": "U heeft uw linklandingspagina-toelage verbruikt. Om meer linklandingspagina's te maken, upgrade uw account of neem contact op met ons ondersteuningsteam.",
            "subscriptionFeatureUnavailable": "Uw huidige abonnementsplan ondersteunt deze functie niet. <1>Upgrade</1> uw abonnementsplan om deze functie te gebruiken.",
            "subscriptionExpired": "Uw abonnement is verlopen. <1>Hervat</1> uw abonnement om deze functie te gebruiken.",
            "noAccess": "U heeft geen toegang tot deze module, neem contact op met het ondersteuningsteam voor meer informatie."
        }
    },
    "add": {
        "title": "Linklandingspagina toevoegen",
        "form": {
            "label": {
                "domain": "Domein",
                "title": "Titel",
                "backUrl": "Terug Url",
                "shortDescription": "Korte Beschrijving",
                "logo": "Logo",
                "backgroundImage": "Achtergrondafbeelding",
                "blurredBackground": "Vervaagde Achtergrond",
                "blurred": "Vervaagd",
                "notBlurred": "Niet Vervagen",
                "blurStrength": "Vervaagsterkte",
                "layout": "Indeling",
                "font": "Lettertype",
                "socialIconPlacement": "Plaatsing Sociale Iconen",
                "socialIconColor": "Kleur Sociale Iconen",
                "buttonCorners": "Hoeken Knop",
                "buttonStyle": "Stijl Knop",
                "colorCustomisation": "Kleuraanpassing",
                "premadeColors": "Vooraf Gemaakte Kleuren",
                "customColors": "Aangepaste Kleuren",
                "headerBackground": "Achtergrond Koptekst",
                "singleColor": "Enkele Kleur",
                "gradient": "Gradiënt",
                "bodyBackground": "Achtergrond Lichaam",
                "titleColor": "Titel Kleur",
                "descriptionColor": "Beschrijving Kleur",
                "buttonColor": "Knop Kleur",
                "buttonTextColor": "Knop Tekstkleur",
                "backgroundColor": "Achtergrondkleur"
            },
            "placeholder": {
                "domain": "Selecteer Domein",
                "shortDescription": "Enkele woorden over uw landingspagina. Maximaal 80 tekens"
            },
            "help_text": {
                "domain": "Selecteer het domein waarvoor u een linklandingspagina wilt maken.",
                "logo": "Upload JPG- of PNG-formaten, resolutie minimaal 500x500 px",
                "backgroundImage": "Upload JPG- of PNG-formaten, resolutie van 1000x1000 px"
            },
            "options": {
                "layout": {
                    "layoutOne": "Indeling Eén",
                    "layoutTwo": "Indeling Twee"
                },
                "socialIconPlacement": {
                    "header": "Koptekst",
                    "bottomOfTheBody": "Onderaan Het Lichaam"
                },
                "socialIconColor": {
                    "color": "Kleur",
                    "black": "Zwart",
                    "white": "Wit"
                },
                "buttonCorners": {
                    "rounded": "Afgerond",
                    "semiRounded": "Semi Afgerond",
                    "squared": "Vierkant"
                },
                "buttonStyle": {
                    "outlined": "Omlijnd",
                    "filled": "Gevuld"
                }
            },
            "button": {
                "submit": "Verzenden"
            },
            "validation": {
                "formInvalid": "Formulier kan niet worden verzonden! Vul alle velden in en controleer op fouten!",
                "storeUrlRequired": "{{store}} Url is vereist",
                "storeUrlValid": "Voeg een geldige {{store}} Url toe."
            }
        },
        "message": {
            "success": "Linklandingspagina is toegevoegd!",
            "error": "Er is iets misgegaan! Vernieuw de pagina en probeer het opnieuw!"
        },
        "modal": {
            "add": {
                "header": "Landingspagina {{title}} toevoegen?",
                "body": "Weet u zeker dat u een linklandingspagina wilt maken met de titel {{title}}?"
            }
        }
    },
    "update": {
        "title": "Linklandingspagina bijwerken",
        "form": {
            "label": {
                "domain": "Domein",
                "title": "Titel",
                "backUrl": "Terug Url",
                "shortDescription": "Korte Beschrijving",
                "logo": "Logo",
                "backgroundImage": "Achtergrondafbeelding",
                "blurredBackground": "Vervaagde Achtergrond",
                "blurred": "Vervaagd",
                "notBlurred": "Niet Vervagen",
                "blurStrength": "Vervaagsterkte",
                "layout": "Indeling",
                "font": "Lettertype",
                "socialIconPlacement": "Plaatsing Sociale Iconen",
                "socialIconColor": "Kleur Sociale Iconen",
                "buttonCorners": "Hoeken Knop",
                "buttonStyle": "Stijl Knop",
                "colorCustomisation": "Kleuraanpassing",
                "premadeColors": "Vooraf Gemaakte Kleuren",
                "customColors": "Aangepaste Kleuren",
                "headerBackground": "Achtergrond Koptekst",
                "singleColor": "Enkele Kleur",
                "gradient": "Gradiënt",
                "bodyBackground": "Achtergrond Lichaam",
                "titleColor": "Titel Kleur",
                "descriptionColor": "Beschrijving Kleur",
                "buttonColor": "Knop Kleur",
                "buttonTextColor": "Knop Tekstkleur",
                "backgroundColor": "Achtergrondkleur"
            },
            "placeholder": {
                "domain": "Selecteer Domein",
                "shortDescription": "Enkele woorden over uw landingspagina. Maximaal 80 tekens"
            },
            "help_text": {
                "domain": "Selecteer het domein waarvoor u een linklandingspagina wilt maken.",
                "logo": "Upload JPG- of PNG-formaten, resolutie minimaal 500x500 px",
                "backgroundImage": "Upload JPG- of PNG-formaten, resolutie van 1000x1000 px"
            },
            "options": {
                "layout": {
                    "layoutOne": "Indeling Eén",
                    "layoutTwo": "Indeling Twee"
                },
                "socialIconPlacement": {
                    "header": "Koptekst",
                    "bottomOfTheBody": "Onderaan Het Lichaam"
                },
                "socialIconColor": {
                    "color": "Kleur",
                    "black": "Zwart",
                    "white": "Wit"
                },
                "buttonCorners": {
                    "rounded": "Afgerond",
                    "semiRounded": "Semi Afgerond",
                    "squared": "Vierkant"
                },
                "buttonStyle": {
                    "outlined": "Omlijnd",
                    "filled": "Gevuld"
                },
                "platform": {
                    "instagram": "Instagram",
                    "facebook": "Facebook",
                    "twitter": "Twitter",
                    "linkedin": "LinkedIn",
                    "tiktok": "TikTok",
                    "youtube": "YouTube",
                    "other": "Andere"
                }
            },
            "button": {
                "submit": "Verzenden"
            }
        },
        "message": {
            "success": "Linklandingspagina is bijgewerkt!",
            "error": "Er is iets misgegaan! Vernieuw de pagina en probeer het opnieuw!"
        },
        "modal": {
            "update": {
                "header": "Landingspagina {{title}} bijwerken?",
                "body": "Weet u zeker dat u de linklandingspagina wilt bijwerken met de titel {{title}}?"
            }
        }
    },
    "socialLinksRow": {
        "title": "Sociale Links",
        "label": {
            "order": "Volgorde",
            "platform": "Platform",
            "destinationUrl": "Bestemming Url"
        },
        "options": {
            "platform": {
                "instagram": "Instagram",
                "facebook": "Facebook",
                "twitter": "Twitter",
                "linkedin": "LinkedIn",
                "tiktok": "TikTok",
                "youtube": "YouTube",
                "other": "Andere"
            }
        },
        "button": {
            "remove": "Verwijderen",
            "add": "Nog Een Toevoegen"
        }
    },
    "featuredLinksRow": {
        "title": "Uitgelichte Links",
        "label": {
            "order": "Volgorde",
            "label": "Label",
            "destinationUrl": "Bestemming Url"
        },
        "button": {
            "remove": "Verwijderen",
            "add": "Nog Een Toevoegen"
        }
    },
    "viewAnalytics": {
        "label": {
            "fetchingAnalytics": "Analytics Ophalen voor Muzieklink"
        },
        "button": {
            "last7Days": "Laatste 7 Dagen",
            "last14Days": "Laatste 14 Dagen",
            "last30Days": "Laatste 30 Dagen"
        },
        "linkLandingPageViews": {
            "title": "Weergaven Linklandingspagina",
            "subtitle": "Totaal Aantal Weergaven",
            "label": {
                "views": "Weergaven"
            }
        },
        "socialLinkClicks": {
            "title": "Klikken op Sociale Links",
            "subtitle": "Totaal Aantal Klikken",
            "table": {
                "column": {
                    "platform": "Platform",
                    "destinationUrl": "Bestemming Url",
                    "clicks": "Klikken",
                    "clicksPct": "Klikken (%)"
                }
            }
        },
        "featuredLinkClicks": {
            "title": "Klikken op Uitgelichte Links",
            "subtitle": "Totaal Aantal Klikken",
            "table": {
                "column": {
                    "label": "Label",
                    "destinationUrl": "Bestemming Url",
                    "clicks": "Klikken",
                    "clicksPct": "Klikken (%)"
                }
            }
        },
        "topTerritories": {
            "title": "Top Gebieden",
            "subtitle": "Totaal Aantal Weergaven",
            "table": {
                "column": {
                    "territory": "Gebied",
                    "views": "Weergaven",
                    "viewsPct": "Weergaven (%)"
                },
                "label": {
                    "otherTerritories": "Andere Gebieden"
                }
            }
        },
        "topBrowsers": {
            "title": "Top Browsers",
            "subtitle": "Totaal Aantal Weergaven",
            "table": {
                "column": {
                    "browser": "Browser",
                    "views": "Weergaven",
                    "viewsPct": "Weergaven (%)"
                }
            }
        },
        "topDeviceTypes": {
            "title": "Top Apparaattypen",
            "table": {
                "column": {}
            }
        },
        "topOperatingSystems": {
            "title": "Top Besturingssystemen",
            "label": {
                "os": "Besturingssysteem",
                "views": "Weergaven"
            }
        }
    }
};

export default linkLandingPagesNL;